module.exports = "./img/95689b1da3b6ee78949cc8c0a21805fb.jpg";